class SlickSlider {
    /**
     * Initializes the Slick slider for the specified selector with customizable options.
     * 
     * @param {string} selector
     * @param {number} [slidesToShow=2]
     */
    static initialize(selector, slidesToShow = 2) {
        const $slider = $(selector);
        const slideCount = $slider.children().length; // This logic only applied to tablet/mobile.

        $slider.slick({
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: slideCount > 4,
                        dots: slideCount <= 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: slideCount > 4,
                        dots: slideCount <= 4
                    }
                }
            ]
        });
    }
}

export default SlickSlider;